// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../packages/util/lib/DateTime.js";
import * as Google_type__Google_type_date from "../../../../proto/third_party/google_type/gen/google_type_date.js";

const include = Google_type__Google_type_date.Google.Type.$$Date;

const make = include.make;

function fromString(value) {
  const datetime = DateTime.fromDateFormat(value);
  return Curry._4(make, datetime.year, datetime.month, datetime.day, undefined);
}

function fromDateTime(datetime) {
  return Curry._4(make, datetime.year, datetime.month, datetime.day, undefined);
}

function toString(date) {
  return (
          date.day < 10 ? "0" + String(date.day) : String(date.day)
        ) + ("." + ((
              date.month < 10 ? "0" + String(date.month) : String(date.month)
            ) + ("." + String(date.year))));
}

const monthSelectOptions = {
  hd: {
    value: 1,
    text: "Января"
  },
  tl: {
    hd: {
      value: 2,
      text: "Февраля"
    },
    tl: {
      hd: {
        value: 3,
        text: "Марта"
      },
      tl: {
        hd: {
          value: 4,
          text: "Апреля"
        },
        tl: {
          hd: {
            value: 5,
            text: "Мая"
          },
          tl: {
            hd: {
              value: 6,
              text: "Июня"
            },
            tl: {
              hd: {
                value: 7,
                text: "Июля"
              },
              tl: {
                hd: {
                  value: 8,
                  text: "Августа"
                },
                tl: {
                  hd: {
                    value: 9,
                    text: "Сентября"
                  },
                  tl: {
                    hd: {
                      value: 10,
                      text: "Октября"
                    },
                    tl: {
                      hd: {
                        value: 11,
                        text: "Ноября"
                      },
                      tl: {
                        hd: {
                          value: 12,
                          text: "Декабря"
                        },
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function findMonthName(month) {
  return Belt__Belt_Option.getWithDefault(Belt__Belt_Option.map(Belt__Belt_List.getBy(monthSelectOptions, (function (opt) {
                        return opt.value === month;
                      })), (function (opt) {
                    return opt.text;
                  })), "");
}

function toDayMonthString(date) {
  return String(date.day) + (" " + findMonthName(date.month));
}

const to_proto = include.to_proto;

const from_proto = include.from_proto;

const to_json = include.to_json;

const from_json = include.from_json;

const name = include.name;

const merge = include.merge;

const to_proto$p = include.to_proto$p;

const from_proto_exn = include.from_proto_exn;

const from_json_exn = include.from_json_exn;

export {
  make ,
  to_proto ,
  from_proto ,
  to_json ,
  from_json ,
  name ,
  merge ,
  to_proto$p ,
  from_proto_exn ,
  from_json_exn ,
  fromString ,
  fromDateTime ,
  toString ,
  monthSelectOptions ,
  findMonthName ,
  toDayMonthString ,
}
/* DateTime Not a pure module */
